import { TTRTimeFilterType } from '../index'
import { ThisConnector } from '../../../api/connector'
import { BaseApiResponse } from '../../../api/shared'

export interface UpdateVulnerabilityTtrTimeFilterTypeArgs {
  organizationUuid: string
  vulnerabilityTTRTimeFilterType: TTRTimeFilterType
}

export async function updateVulnerabilityTtrTimeFilterType(
  this: ThisConnector,
  {
    organizationUuid,
    vulnerabilityTTRTimeFilterType
  }: UpdateVulnerabilityTtrTimeFilterTypeArgs
) {
  return this.connector.put<BaseApiResponse>(
    `organizations/${organizationUuid}/ttr/properties`,
    {
      vulnerabilityTTRTimeFilterType
    }
  )
}
